import Vue from 'vue';
import { _api } from '@/utils/apiAxios';
import { LoginTypes, ExternalWagerLoginTypes } from '@/utils/enums';
import i18n from '@/utils/i18n';
import { getField, updateField } from 'vuex-map-fields';
import {
  createBet,
  buildBets,
  getBetIndex,
  getSelectionIndex,
  getSelectedPointObjectFromBetOptions,
  getSelectedTeaserObjectFromBetOptions,
  persistBets,
  persistSelections,
  persistNewSelections,
  restoreBets,
  restoreSelections,
  restoreNewSelections,
  persistGameDetails,
  restoreGameDetails,
  clearBetsAndSelectionsFromStorage,
  persistBetSlip,
  restoreBetSlip,
  roundAmount,
  getWinAmount,
  getWinAmountRR,
} from '../components/bet-slip/bet-slip-utils';
import { List, fromJS } from 'immutable';
import { PRINTERS, printWagerTicket } from '@/plugins/printFactory';

const TWEEN = require('@tweenjs/tween.js');
import { log } from '@/utils/logging';
import router from '@/router';
import {
  checkedSelectionStore,
  isChecked,
  liveSelectionStore,
  setChecked,
  setLive,
  removeLive,
} from '@/views/sports/components/bet-slip/check-bets';
import { persistRoundRobinTab, restoreRoundRobinTab } from '@/views/sports/components/bet-slip/bet-slip-utils';
import snq from 'snq';
import { uniqBy, isNil } from 'lodash';
import store from '@/store';
import { mapGetters } from 'vuex';
import { openErrorModal } from '../../../utils/modalHelper';
import { isElectronContext } from '../../../utils/isElectron';

let checkLineAvailabilityInterval = null;

const isElectron = isElectronContext() || typeof Epos_Android_Interface != 'undefined';

export const defaultRoundRobinTabContext = {
  roundRobinsAmounts: {
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
    6: null,
    7: null,
    8: null,
    99: null,
  },
  straightBetRiskAmount: null,
};

function betsTax(bets) {
  const taxHelper = Vue.prototype.$taxHelper;
  const mustApplyTax = taxHelper.mustApplyTax;
  if (mustApplyTax) {
    bets = bets.Selections.map(bet => {
      const appliedTaxRiskInputHidden = taxHelper.applyTaxToRiskInputHidden({
        input_risk_amount: bet.input_risk_amount,
      });

      return {
        ...bet,
        input_risk_amount: appliedTaxRiskInputHidden,
      };
    });
  }

  return bets;
}

const getDefaultState = () => {
  return {
    newBetSlipSelection: restoreNewSelections() ? restoreNewSelections() : [],
    newBetSlipTabs: [
      { type: 'straight', count: 1 },
      { type: 'parlay', count: 2 },
      { type: 'round_robin', count: 3 },
      { type: 'if_win', count: 2 },
      { type: 'if_win_or_tie', count: 2 },
      // { type: 'reverse', count: 2 },
    ],
    newBetOptionsResponse: null,
    selections: restoreNewSelections() ? fromJS(List(restoreNewSelections())) : List(),
    checkedSelections: [],
    liveSelections: [],
    bets: restoreBets() ? fromJS(List(restoreBets())) : List(),
    roundRobinTab: restoreRoundRobinTab(),
    GAME_DETAILS_MAP: restoreGameDetails(),
    betTabs: [],
    selectedType: 'straight',
    selectedTypeName: 'BetSlip.Straight',
    currentState: 'BET_PREPARE', // BET_PREPARE | BET_CONFIRMATION | BET_PLACED
    betConfirmationIds: [],
    betConfirmationResponse: [],
    betConfirmationDisabledLines: [],
    showDisabledLinesModal: false,
    betConfirmationStatus: {
      loading: false,
      success: false,
      error: false,
    },
    betConfirmationErrors: [],
    betOptionsResponse: null,
    betOptionsStatus: {
      loading: false,
      success: false,
      error: false,
    },
    betPlaceResponse: {
      generated_bets: [],
      bet_scan_code: '',
      test: '',
    },
    betPlaceStatus: {
      loading: false,
      success: false,
      error: false,
    },
    registerBetStatus: {
      loading: false,
      success: false,
      error: false,
    },
    betPlaceIterationCount: 0,
    betSlipOpened: false,
    rejectingBets: {},
    sideMode: 'BET_SLIP_TAB', // BET_SLIP_TAB | OPEN_BETS_TAB
    showLoginNeedModal: false,
    validity: true,
    betSlipBetCount: restoreNewSelections() ? restoreNewSelections().length : 0,
    retainBets: false,
    totalRiskWithoutTax: 0,
    placedBets: [],
    acceptOddChanges: false,
    printing: false,
    confirmationData: null,
    roundRobins: [],
  };
};

const state = { ...getDefaultState(), activeFreeBet: false };

const getters = {
  getField,
  isAnyOddChanged: state =>
    state.betOptionsResponse.Selections.filter(selection => selection.wait_for_accept === true).length > 0,
};

const mutations = {
  updateField,
  setNewBetSelection: (state, selection) => {
    state.newBetSlipSelection = selection;
    persistNewSelections(selection);
    state.betSlipBetCount = selection.length;
  },
  setSelections: (state, selections) => {
    state.selections = selections;
    persistSelections(selections);
    state.betSlipBetCount = selections.size;
  },
  setPrinting: (state, value) => {
    state.printing = value;
  },
  setRRStraightBetRiskAmount: (state, inputValue) => {
    state.roundRobinTab.straightBetRiskAmount = inputValue;
    persistRoundRobinTab(state.roundRobinTab);
  },
  setRRFoldBeRiskAmount: (state, { inputValue, parlay_size }) => {
    let roundRobinsAmounts = state.roundRobinTab.roundRobinsAmounts;

    if (!roundRobinsAmounts) {
      roundRobinsAmounts = {};
    }

    roundRobinsAmounts[parlay_size] = inputValue;

    state.roundRobinTab.roundRobinsAmounts = roundRobinsAmounts;
    persistRoundRobinTab(state.roundRobinTab);
  },
  setBetCount: (state, count) => {
    state.betSlipBetCount = count;
  },
  setActiveFreeBet(state, isActive) {
    state.activeFreeBet = isActive ? true : false;
  },
  setBets: (state, bets) => {
    state.bets = bets;
    persistBets(bets);
  },
  setTabs(state, tabs) {
    state.betTabs = tabs;
  },
  setSelectedBetType(state, { type, name }) {
    state.selectedType = type;
    state.selectedTypeName = name;
  },
  setCurrentState(state, currentState) {
    state.currentState = currentState;
    if (currentState === 'BET_PREPARE') {
      state.betPlaceResponse = {
        generated_bets: [],
        bet_scan_code: '',
        test2: '',
      };
    }

    console.log('currentState', { currentState });
  },
  setValidity(state, validity) {
    state.validity = validity;
  },
  setBetConfirmationIds(state, betConfirmationIds) {
    state.betConfirmationIds = betConfirmationIds;
  },
  removeBetConfirmationId(state, bet) {
    const filteredItems = state.betConfirmationIds.filter(_id => _id !== bet.bet.id);
    state.betConfirmationIds = filteredItems;
  },
  addBetConfirmationId(state, bet) {
    let betIds = state.betConfirmationIds;
    betIds.push(bet.bet.id);
    betIds = [...new Set(betIds)];
    state.betConfirmationIds = betIds;
  },
  addRejectedBet(state, { identifier, bet }) {
    state.rejectingBets[identifier] = bet;
  },
  removeRejectedBet(state, { identifier }) {
    delete state.rejectingBets[identifier];
  },
  setBetConfirmationResponse(state, response) {
    state.betConfirmationResponse = response;
  },
  setBetConfirmationDisabledLines(state, betConfirmationDisabledLines) {
    state.betConfirmationDisabledLines = betConfirmationDisabledLines;
  },
  setShowDisabledLinesModal(state, showDisabledLinesModal) {
    state.showDisabledLinesModal = showDisabledLinesModal;
  },
  updateBetConfirmationStatus(state, row) {
    state.betConfirmationStatus = {
      ...state.betConfirmationStatus,
      ...row,
    };
  },
  updateRegisterBetStatus(state, row) {
    state.registerBetStatus = {
      ...state.registerBetStatus,
      ...row,
    };
  },
  updateBetPlaceStatus(state, row) {
    state.betPlaceStatus = {
      ...state.betPlaceStatus,
      ...row,
    };
  },
  increaseBetPlaceIterationCount(state) {
    state.betPlaceIterationCount = state.betPlaceIterationCount + 1;
  },
  updateBetOptionsStatus(state, row) {
    state.betOptionsStatus = {
      ...state.betOptionsStatus,
      ...row,
    };
  },
  setBetConfirmationErrors(state, data) {
    state.betConfirmationErrors = data;
  },
  resetRiskAndWinAmounts(state) {
    state.bets = (state.bets || []).map(bet => {
      bet.input_risk_amount = '';
      bet.input_win_amount = '';
      return bet;
    });
    persistBets(state.bets);
  },
  // eğer place bet üzerinden bu methoda gelindiyse ve retainBets açıksa checkbox ile işaretlenmiş bahisleri SİLMEMEK gerek
  resetBetSlip(state, isPlaceBet) {
    document.body.classList.remove('overflow-hidden');

    const retainedBets = state.betOptionsResponse;
    const lineSelections = state.newBetSlipSelection;
    const gameDetails = state.GAME_DETAILS_MAP;
    const checkedSelections = checkedSelectionStore();
    const liveSelections = liveSelectionStore();

    // gameDetails olayları line selection içinde geldiği için artık onunla alakalı şeyler silinecek.
    // o yüzden burada localstorage boşaltmıyorum

    if (isPlaceBet && !!state.retainBets) {
      clearBetsAndSelectionsFromStorage(retainedBets, lineSelections, gameDetails, checkedSelections, liveSelections);
    } else {
      clearBetsAndSelectionsFromStorage([], [], {}, [], []);
    }

    Object.assign(state, getDefaultState());
  },
  setBetOptionsResponse(state, response) {
    // const availableTypes = snq(() => response.options.available_types, []);
    // if (state.selectedType === 'round_robin') {
    //   if (!snq(() => response[0].error)) {
    //     const totalParlayCount = availableTypes.reduce((a, c) => a + c.parlay_count, 0);
    //     // TODO: checked
    //     if (snq(() => response[0].bet.line_selections, []).length > 3) {
    //       response[0].options.available_types.push({
    //         parlay_size: 99,
    //         parlay_count: totalParlayCount,
    //       });
    //     }
    //     try {
    //       response[0].options.available_types = uniqBy(
    //         snq(() => availableTypes, []),
    //         'parlay_size',
    //       );
    //     } catch (err) { }
    //   }
    // }

    // response = (response || []).map((bet) => {
    //   return {
    //     ...bet,
    //     line_selections: snq(() => bet.bet.line_selections, []).map((selection) => {
    //       if (+selection.points !== 0) {
    //         const foundPointOptions = [...(selection.point_options || [])].find(
    //           (o) => +o.buy_points === +selection.points,
    //         );

    //         if (foundPointOptions) {
    //           selection.points = foundPointOptions.buy_points;
    //           selection.odds = foundPointOptions.odds;
    //           selection.spread = foundPointOptions.spread;
    //         }
    //       }

    //       if (!!selection.pitcher_selection) {
    //         const foundPitcher = [...(selection.pitcher_options || [])].find(
    //           (o) => o.name === selection.pitcher_selection,
    //         );

    //         if (foundPitcher) {
    //           selection.pitcher_selection = foundPitcher.name;
    //           this.dispatch('betSlip/updatePitcherSelection', {
    //             selection_identifier: selection.selection_identifier,
    //             pitcher: foundPitcher,
    //           });
    //         }
    //       }

    //       return selection;
    //     }),
    //   };
    // });

    state.betOptionsResponse = response;
    persistBetSlip(response);
  },
  setNewBetOptionsResponse(state, response) {
    console.log({ response });
    state.betOptionsResponse.Selections.map(slc => slc.OutComeId === response.OutComeId || slc);
    persistBetSlip(state.betOptionsResponse);
  },

  setBetPlaceResponse(state, { betPlaceResponse, isDomine = false }) {
    console.log({ betPlaceResponse, isDomine });
    state.betPlaceResponse = betPlaceResponse;

    // function pushToArray(arr, obj) {
    //   const item = arr.find(e => e.bet.id === obj.bet.id);
    //   const index = arr.findIndex(e => e.bet.id === obj.bet.id);
    //   if (!item) {
    //     arr.push(obj);
    //   } else {
    //     arr[index] = obj;
    //   }
    // }

    // if (isDomine) {
    //   const generated_bets = (betPlaceResponse && betPlaceResponse) || [];
    //   let currentGenerated_bets = [...state.betPlaceResponse];

    //   generated_bets.forEach(item => {
    //     pushToArray(currentGenerated_bets, item);
    //   });

    //   state.betPlaceResponse = betPlaceResponse;
    // } else {
    //   state.betPlaceResponse = betPlaceResponse;
    // }
  },
  setShowLoginNeedModal(state, val) {
    state.showLoginNeedModal = val;
  },
  updateGameDetailsMap: (state, { selection_id, game_description, team_name }) => {
    state.GAME_DETAILS_MAP[selection_id] = {
      game_description: game_description,
      team_name: team_name,
    };
    persistGameDetails(state.GAME_DETAILS_MAP);
  },
  removeFromGameDetailsMap: (state, { selection_id }) => {
    delete state.GAME_DETAILS_MAP[selection_id];
    persistGameDetails(state.GAME_DETAILS_MAP);
  },
  acceptAllOddsChange(state) {
    state.betOptionsResponse.Selections.filter(selection => selection.wait_for_accept === true).map(item => {
      item.wait_for_accept = false;
    });
  },
  openBetSlip(state) {
    state.betSlipOpened = true;
    if (window.innerWidth < 1440) {
      document.body.classList.add('overflow-hidden');
    }
  },
  closeBetSlip(state) {
    state.betSlipOpened = false;
    document.body.classList.remove('overflow-hidden');
  },
  toggleBetSlip(state) {
    state.betSlipOpened = !state.betSlipOpened;
    if (state.betSlipOpened) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  },
  retainBets(state, value) {
    state.retainBets = value;
  },
  setTotalRiskWithoutTax(state, value) {
    state.totalRiskWithoutTax = value;
  },
  setPlacedBets(state, value) {
    // state.placedBets = [...state.placedBets, ...value];
    state.placedBets = [...value];
  },
  removePlacedBets(state) {
    state.placedBets = [];
  },
  setConfirmationData(state, value) {
    state.confirmationData = value;
  },
  setRoundRobinsData(state, value) {
    state.roundRobins = value;
  },
};

const actions = {
  renderBetSlip: ({ state, commit, dispatch, rootState }) => {
    var betSlipSelections = restoreNewSelections();
    commit('setNewBetSelection', betSlipSelections);
    var betslipObject = restoreBetSlip();
    if (!betslipObject) return;
    if (!betslipObject.Selections) return;
    dispatch('getBetTabs');
    commit('setBetOptionsResponse', betslipObject);
  },
  addBetToBetSlipV3: (
    { state, commit, dispatch, rootState },
    { odd, marketType, sportType, event, game_description, team_name, isLive, lineTournamentId },
  ) => {
    commit('setCurrentState', 'BET_PREPARE');
    var betSlipRequest = {
      WagerType: 0,
      OutComeList: [],
    };
    betSlipRequest.OutComeList = state.newBetSlipSelection ? state.newBetSlipSelection : [];

    var isExist = betSlipRequest.OutComeList.some(a => a.Id === odd.id);
    if (isExist) {
      //remove current
      var existBets = betSlipRequest.OutComeList.filter(a => a.Id != odd.id);
      betSlipRequest.OutComeList = existBets;
      if (isLive) {
        removeLive(odd.id);
      }
    } else {
      var addItem = {
        Id: odd.id,
        MarketType: marketType,
        SportId: sportType,
        LineTournamentId: lineTournamentId
      };
      betSlipRequest.OutComeList.push(addItem);
      if (isLive) {
        setLive(odd.id);
      }
    }

    commit('setNewBetSelection', betSlipRequest.OutComeList);
    dispatch('getBetTabs');
    dispatch('getNewBetOptions');
  },
  // called from bet line odd click event
  // populates selection array and bets array
  // microservices accepts bets with this format:
  addBetToBetSlip: (
    { state, commit, dispatch, rootState },
    { odd, sportType, event, game_description, team_name, isLive },
  ) => {
    commit('setCurrentState', 'BET_PREPARE');
    commit('removePlacedBets');

    const idSplitted = odd.id.split('_');
    const selection = {
      id: odd.id,
      dgs_game_id: idSplitted[0],
      dgs_participant_id: idSplitted[1],
      dgs_sport_id: sportType,
      line: idSplitted[2],
      spread: odd.spread_value || 0,
      odds: odd.odd_value || 0,
      new_spread: odd.spread_value || 0,
      new_odds: odd.odd_value || 0,
      points: 0,
      checked: true,
    };

    setChecked(odd.id);

    if (isLive) {
      setLive(odd.id);
    }

    commit('updateGameDetailsMap', {
      selection_id: odd.id,
      game_description: game_description,
      team_name: team_name,
    });
    const selections = state.selections;
    // remove selection if already exists
    const isExist = selections.some(item => item.id === selection.id);
    if (isExist) {
      log('[BETSLIP] removed selection from bet slip', selection);
      const newSelections = selections.filter(item => item.id !== selection.id);
      commit('setSelections', newSelections);
      dispatch('removeBetFromSlip', {
        selection_id: selection.id,
        get_options: true,
      });

      // commit("setBetCount", newSelections.size);

      if (newSelections.size === 0) {
        commit('resetBetSlip');
      }
    } else {
      log('[BETSLIP] added selection to bet slip', selection);
      dispatch('freeWagerStore/beforeAddBetToBetSlipCheckFreeWager', null, {
        root: true,
      });

      const betParams = createBet('straight', selection.id, 0, 0, 0, 0, null, true);
      dispatch('createOrUpdateBet', betParams);

      const newSelections = selections.push(selection);
      commit('setSelections', newSelections);

      let betTypes = ['teaser', 'parlay', 'if_win', 'reverse', 'round_robin'];
      let restore = restoreBets() ? fromJS(List(restoreBets())) : List();

      betTypes.forEach(betType => {
        let restoreItem = restore.find(item => item.type === betType);
        if (state.selectedType === betType) {
          if (restoreItem) {
            dispatch(
              'createOrUpdateBet',
              createBet(betType, selection.id, restoreItem.input_risk_amount, 0, 0, 0, 0, true),
            );
          } else {
            dispatch('createOrUpdateBet', createBet(betType, selection.id, 0, 0, 0, 0, 0, true));
          }
        } else {
          if (restoreItem) {
            dispatch('createOrUpdateBet', createBet(betType, 0, restoreItem.input_risk_amount, 0, 0, 0, 0, true));
          } else {
            dispatch('createOrUpdateBet', createBet(betType, 0, 0, 0, 0, 0, 0, true));
          }
        }
      });

      dispatch(
        'freeWagerStore/afterAddBetToBetSlipCheckFreeWagerAndBuildBets',
        { selection: selection },
        { root: true },
      );
      dispatch('getBetTabs');
      dispatch('getBetOptions');
      // commit("setBetCount", newSelections.size);

      // // For mobile only, apply animate
      // if (window.innerWidth < 992) {
      //     animateOddObjectToBetslip(odd, event);
      // }
    }
  },
  createOrUpdateBet: ({ state, commit, rootState }, betParams) => {
    // create or update parent bet for that selection

    const bets = state.bets;
    const type = betParams.type;
    const betid = betParams.betid;
    let free_wager_prize_id = null;

    if (rootState.freeWagerStore.freeWagersViewing) {
      free_wager_prize_id = rootState.freeWagerStore.selectedFreeWager.freeWagerPrizeId;
    }

    // log("bet_index = ", bet_index)
    if (betid != '' && type != 'straight') {
      let bet_index = getBetIndex(bets, 'straight', betid);
      if (bet_index === false) {
        const newBets = bets.push(betParams);
        commit('setBets', newBets);
      }
    }

    let bet_index = getBetIndex(bets, type, betid);
    if (bet_index === false) {
      const newBets = bets.push(betParams);
      commit('setBets', newBets);
    } else {
      // if (betParams.input_risk_amount > 0) { ? investigate this
      const newBets = bets.update(bet_index, bet => {
        return {
          ...bet,
          input_risk_amount: betParams.input_risk_amount || 0,
          input_win_amount: betParams.input_win_amount || 0,
          open_spots: betParams.open_spots,
          type: type,
          sub_type: betParams.sub_type,
          free_wager_prize_id: free_wager_prize_id,
          checked: betParams.checked === undefined ? bet.checked : betParams.checked,
        };
      });

      commit('setBets', newBets);
    }
  },
  removeBetFromSlip: ({ state, commit, dispatch }, { selection_id, get_options, reset = true }) => {
    console.log('removeBetFromSlip', selection_id);
    const bets = state.bets;
    let filteredBets = bets.filter(r => r.betid !== selection_id);

    if (state.selections.size === 1 && state.selectedType === 'straight') {
      // filteredBets = bets.filter(r => !!r.betid);
    }

    commit('setBets', filteredBets);
    commit('removeFromGameDetailsMap', { selection_id });

    if (filteredBets.size === 0 && reset) {
      commit('resetBetSlip');
    }

    if (get_options) {
      dispatch('getBetTabs');
      dispatch('getNewBetOptions');
    }
  },
  removeBetFromSlipByIndex: ({ state, commit, dispatch }, index) => {
    // const newBets = state.bets.filter((_, i) => i !== index);
    // commit("setBets", newBets);
    let betSlipSelectionObject = state.newBetSlipSelection;
    if (betSlipSelectionObject) {
      const newSelections = betSlipSelectionObject.filter(bet => bet.Id !== index);
      commit('setNewBetSelection', newSelections);
    }

    // commit("setBetCount", newSelections.size);
    let betSlipObject = state.betOptionsResponse;
    if (betSlipObject) {
      const betOptionsResponseCloned = betSlipObject.Selections.filter(bet => bet.OutComeId !== index);
      betSlipObject.Selections = betOptionsResponseCloned;
      commit('setBetOptionsResponse', betSlipObject);
    }

    dispatch('renderBetSlip');
  },
  removeBetFromSlipByType: ({ state, commit }, type) => {
    console.log('removeBetFromSlipByType', { type });
    const newBets = state.bets.filter(bet => bet.type !== type && bet.type === 'straight');
    commit('setBets', newBets);

    const betOptionsResponseCloned = state.betOptionsResponse.filter(
      bet => bet.type !== type && bet.bet.type === 'straight',
    );
    commit('setBetOptionsResponse', betOptionsResponseCloned);
  },
  removeBetFromSelections: ({ state, commit, dispatch }, selection_id) => {
    const selections = state.newBetSlipSelection;
    const newSelections = selections.filter(r => r.Id !== selection_id);
    commit('setNewBetSelection', newSelections);

    if (newSelections.size === 0) {
      commit('resetBetSlip');
    }

    let betOptionsResponseCloned = state.betOptionsResponse;

    betOptionsResponseCloned.Selections = betOptionsResponseCloned.Selections.filter(
      selection => selection.OutComeId !== selection_id,
    );
    commit('setBetOptionsResponse', betOptionsResponseCloned);
    commit('removeFromGameDetailsMap', { selection_id });

    dispatch('getBetTabs');
    dispatch('getNewBetOptions');
  },
  clearBetSlip: ({ commit }) => {
    commit('resetBetSlip');
  },
  updatePointsSelection: ({ state, commit }, buyPointParams) => {
    const selections = state.newBetSlipSelection;
    let selectedSelection = getSelectionIndex(selections, buyPointParams.selection_identifier);
    if (!selectedSelection) {
      // log("selection_index is not found for", buyPointParams)
      return;
    }

    let buyPointOptions = getSelectedPointObjectFromBetOptions(
      state.betOptionsResponse,
      buyPointParams.selection_identifier,
      buyPointParams.points,
      state.selectedType,
    );

    if (buyPointParams.points === 0) {
      buyPointOptions = {
        buy_points: 0,
        odds: selectedSelection.odds,
        spread: selectedSelection.spread,
      };
    }

    // const newSelections = filteredSelections.push({
    //   ...selectedSelection,
    //   points: buyPointOptions.buy_points,
    //   new_odds: buyPointOptions.odds,
    //   new_spread: buyPointOptions.spread,
    // });
    // log("newSelections", newSelections)
    // commit('setSelections', newSelections);
    let clonedBetOptions = state.betOptionsResponse;
    clonedBetOptions.Selections = clonedBetOptions.Selections.map(betOuter => {
      if (betOuter && betOuter.AvailableBuyPoints) {
        if (betOuter.OutComeId === buyPointParams.selection_identifier) {
          // selection.points = buyPointOptions.buy_options; already set using v-model
          if (buyPointParams.reset_buy_point) {
            Vue.set(betOuter, 'Point', betOuter.OriginalPoint);
            Vue.set(betOuter, 'Odd', betOuter.OriginalOdd);
            Vue.set(betOuter, 'OutComeDescription', betOuter.OriginalDescription);
            Vue.set(betOuter, 'PointPurchased', null);
            Vue.set(betOuter, 'BuyPointOutcomeId', null);
            Vue.set(betOuter, 'odds_modified_by_user', false);
          } else {
            Vue.set(betOuter, 'OriginalPoint', betOuter.Point);
            Vue.set(betOuter, 'OriginalOdd', betOuter.Odd);
            Vue.set(betOuter, 'OriginalDescription', betOuter.OutComeDescription);

            Vue.set(betOuter, 'Point', buyPointOptions.Point);
            Vue.set(betOuter, 'Odd', buyPointOptions.Odd);
            Vue.set(betOuter, 'OutComeDescription', buyPointOptions.OutcomeDescription);
            Vue.set(betOuter, 'PointsPurchased', buyPointOptions.PointVal);
            Vue.set(betOuter, 'BuyPointOutcomeId', buyPointOptions.OutComeId);
            Vue.set(betOuter, 'odds_modified_by_user', true);
          }
        }
      }
      return betOuter;
    });
    // log("betOptionsResponseCloned", betOptionsResponseCloned)
    commit('setBetOptionsResponse', clonedBetOptions);
  },
  updateTeaserSelection({ state, commit }, teaserParams) {
    const betOptionsResponseCloned = state.betOptionsResponse;
    betOptionsResponseCloned.IdWagerType = teaserParams.wager_type_id;
    betOptionsResponseCloned.SelectedTeaser = teaserParams.selected_teaser;
    betOptionsResponseCloned.Selections.forEach(s => {
      let pointReplace;
      if (s.SportId == betOptionsResponseCloned.TeaserSupports.TeaserFootball)
        pointReplace = teaserParams.selected_teaser.FootballPoint;
      else if (s.SportId == betOptionsResponseCloned.TeaserSupports.TeaserBasketball)
        pointReplace = teaserParams.selected_teaser.BasketballPoint;
      if ( isNil(s.OriginalPoint) ) {
        s.OriginalPoint = s.Point;
      }
      let newPoint;
      let replaceText;
      if (s.MarketType == 'sp') {
        newPoint = s.OriginalPoint + pointReplace;
        replaceText = s.Point > 0 ? `+${s.Point}` : `${s.Point}`;
        s.OutComeDescription = s.OutComeDescription.replace(replaceText, newPoint > 0 ? `+${newPoint}` : `${newPoint}`);
      }
      else if (s.MarketType == 'to') {
        if (s.ProviderOutComeId % 2 == 0) {
          newPoint = s.OriginalPoint - pointReplace;
        } else {
          newPoint = s.OriginalPoint + pointReplace;
        }
        replaceText = `${s.Point}`;
        s.OutComeDescription = s.OutComeDescription.replace(replaceText, `${newPoint}`);
      }
      s.Point = newPoint;
    });

    commit('setBetOptionsResponse', betOptionsResponseCloned);
  },
  updatePitcherSelection: ({ state, commit }, pitcherParams) => {
    const betOptionsResponseCloned = state.betOptionsResponse;
    betOptionsResponseCloned.Selections = betOptionsResponseCloned.Selections.map(s => {
      if (pitcherParams.selection_identifier == s.OutComeId) {
        s.Pitcher = pitcherParams.pitcher.Id;
      }
      return s;
    });
    commit('setBetOptionsResponse', betOptionsResponseCloned);
  },
  updateBetFreeWager: ({ state, commit }, use_free_play) => {
    const bets = state.bets;
    const newBets = bets.map(bet => {
      bet.use_free_play = use_free_play;
      return bet;
    });
    commit('setActiveFreeBet', use_free_play);
    commit('setBets', newBets);
  },
  // get available bet types from services
  // web service accepts selections as input
  getBetTabs: ({ state, commit, rootState }) => {
    const selections = state.newBetSlipSelection;
    const formData = {
      ListSelection: selections.map(f => {
        return { LineSportId: f.SportId };
      }),
    };

    if (selections.length === 0) {
      return;
    }

    const mustHideStraight = selections.length >= 2 && isElectron;
    if (mustHideStraight) {
      commit('setSelectedBetType', { type: 'parlay', name: 'BetSlip.Parlay' });
    } else {
      if (state.selectedType === 'straight')
        commit('setSelectedBetType', { type: 'straight', name: 'BetSlip.Straight' });
      else if (state.selectedType === 'parlay' && !mustHideStraight)
        commit('setSelectedBetType', { type: 'straight', name: 'BetSlip.Straight' });
    }
    _api.post('/v2/bet/gettabs', formData).then(res => {
      if (res.data.IsSuccess) {
        let tabs = res.data.Data;

        // if more then 2 selection and is kiosk, remove straight tab
        if (mustHideStraight) {
          tabs = tabs.filter(tab => tab !== 'straight');
        } else {
          tabs = tabs.filter(tab => tab === 'straight');
        }

        //EPSN-4196 Remove Ifbet and Reverses from betslip in Epos
        if (isElectron) {
          tabs = tabs
            .filter(tab => tab !== 'if_bet')
            .filter(tab => tab !== 'reverse')
            .filter(tab => tab !== 'if_win')
            .filter(tab => tab !== 'if_win_or_tie');
        }
        console.log(state.selectedType);
        commit('setTabs', tabs);

        if (rootState.freeWagerStore.freeWagersViewing && rootState.freeWagerStore.selectedFreeWager.id) {
          const wager_type = rootState.freeWagerStore.selectedFreeWager.wager_type;

          // filter tabs for allowed wager type when in free wager mode
          tabs = tabs.filter(tab => tab === wager_type);
          commit('setTabs', tabs);
          commit('setSelectedBetType', { type: wager_type, name: '' });
        }
      }
    });
  },
  // get available bet options from services
  // web service accepts bets and it's selections as input, which built in buildBets()
  getNewBetOptions: ({ state, commit, dispatch, rootState }, params) => {
    // get bet options using bets
    if (state.newBetSlipSelection.length === 0) {
      // commit("resetBetSlip");
      return;
    }

    commit('updateBetOptionsStatus', { loading: true });
    const formData = {
      WagerType: state.selectedType,
      MacAddress: rootState.settings.macAddress,
      ClientType: rootState.settings.clientType,
      OutComeList: state.newBetSlipSelection,
    };
    _api.post('/v2/bet/getbetslip', formData).then(res => {
      if (res.data.IsSuccess) {
        let betOptionsResponse = res.data.Data;

        const data = JSON.parse(localStorage.getItem('new_betslip'));

        if (data && data.Selections) {
          betOptionsResponse.Selections.forEach(slc => {
            data.Selections.forEach(ds => {
              if (ds.OutComeId === slc.OutComeId && ds.input_risk_amount) {
                slc.input_risk_amount = ds.input_risk_amount;
                slc.input_win_amount = ds.input_win_amount;
              }
            });
          });
        }

        betOptionsResponse.Selections.forEach(slc => {
          slc.LineTournamentId = state.newBetSlipSelection.find(item => item.id === slc.OutcomeId)['LineTournamentId']
        });

        commit('setBetOptionsResponse', betOptionsResponse);
        if (!betOptionsResponse.Selections.length && betOptionsResponse.IsSuccess) {
          dispatch('clearBetSlip');
        }
        commit('updateBetOptionsStatus', { success: true, error: false });

        // if (rootState.freeWagerStore.freeWagersViewing) {
        //   window.postMessage('BET_SLIP_FREE_WAGER_TRIGGER_RISK_CHANGE');
        // }
      } else {
        commit('updateBetOptionsStatus', {
          success: false,
          error: i18n.t('BetSlip.ErrorLoading'),
        });
      }

      commit('updateBetOptionsStatus', { loading: false });
    });
  },
  getBetOptions: ({ state, commit, dispatch, rootState }, params) => {
    // get bet options using bets
    if (state.selections.size === 0) {
      // commit("resetBetSlip");
      return;
    }
    const getCheckeds = params && params.getCheckeds;

    const bets = buildBets(state, true, getCheckeds, true);
    commit('updateBetOptionsStatus', { loading: true });
    const formData = {
      MacAddress: rootState.settings.macAddress,
      bets,
      ClientType: rootState.settings.clientType,
    };
    _api.post('/bet/options', formData).then(res => {
      if (res.data.IsSuccess) {
        let betOptionsResponse = res.data.Data;
        if (state.selectedType === 'straight') {
          betOptionsResponse = betOptionsResponse.filter(bet => {
            if (bet.bet.type === 'parlay' || bet.bet.type === 'teaser') {
              return !bet.error;
            }
            return true;
          });
        }
        commit('setBetOptionsResponse', betOptionsResponse);
        if (!betOptionsResponse.length) {
          dispatch('clearBetSlip');
        }
        commit('updateBetOptionsStatus', { success: true, error: false });
        if (params && params.checkLineAvailability) {
          dispatch('checkLineAvailability');
        }

        if (rootState.freeWagerStore.freeWagersViewing) {
          window.postMessage('BET_SLIP_FREE_WAGER_TRIGGER_RISK_CHANGE');
        }
      } else {
        commit('updateBetOptionsStatus', {
          success: false,
          error: i18n.t('BetSlip.ErrorLoading'),
        });
      }

      commit('updateBetOptionsStatus', { loading: false });
    });
  },
  getNewBetConfirmations: ({ state, rootState, commit }, betOptions) => {
    if (state.betPlaceStatus.loading) {
      return;
    }
    if (state.betConfirmationStatus.loading) {
      return;
    }
    commit('updateBetConfirmationStatus', { loading: true });
    commit('updateBetPlaceStatus', {
      loading: false,
      success: false,
      error: false,
    });
    commit('setShowDisabledLinesModal', false);

    const confirmationResponse = betOptions;

    commit('setBetConfirmationResponse', confirmationResponse);
    commit('setCurrentState', 'BET_CONFIRMATION');
    commit('updateBetConfirmationStatus', { loading: false });
  },
  // first state of bet placing
  // web service accepts bets and it's selections as input, which built in buildBets()
  // returns bet ids which are in the state of waiting
  getBetConfirmations: ({ state, rootState, commit }) => {
    // get bet confirmations using bets
    if (state.betPlaceStatus.loading) {
      return;
    }

    if (state.betConfirmationStatus.loading) {
      return;
    }
    commit('updateBetConfirmationStatus', { loading: true });
    commit('updateBetPlaceStatus', {
      loading: false,
      success: false,
      error: false,
    });

    let selections = state.newBetSlipSelection;

    let bets = buildBets(state, false, true);
    log('get bet confirmations param:', bets);

    const formData = {};

    bets = betsTax(bets);

    if (
      rootState.player.loginType === LoginTypes.Player ||
      rootState.player.loginType === ExternalWagerLoginTypes.RealPlayerKiosk
    ) {
      getBetConfirmationsRealPlayer();
    }

    if (
      rootState.player.loginType === ExternalWagerLoginTypes.DepositTicket ||
      rootState.player.loginType === ExternalWagerLoginTypes.ClerkDepositTicket
    ) {
      getBetConfirmationsDepositTicket();
    }

    if (rootState.player.loginType === ExternalWagerLoginTypes.MobileScanCode) {
      getBetConfirmationsMobileScanCode();
    }

    if (rootState.player.loginType === LoginTypes.Clerk) {
      getBetConfirmationsClerk();
    }

    function getBetConfirmationsRealPlayer() {
      formData.bets = bets;
      formData.selections = selections;
      if (state.betPlaceStatus.loading) {
        return;
      }
      _api
        .post('/v2/bet/placebetrealplayer', formData, {
          headers: {
            'X-Forwarded-For': rootState.settings.userIpInfo.ip,
          },
        })
        .then(getBetConfirmationCallback);
    }

    function getBetConfirmationsDepositTicket() {
      formData.bets = bets;
      formData.selections = selections;
      formData.LoginType = ExternalWagerLoginTypes.DepositTicket;
      formData.ScanCode = rootState.depositTicketStore.scanCode; // sending for balance control and authentication
      formData.MacAddress = rootState.settings.macAddress;
      formData.ScanType = rootState.depositTicketStore.balanceResponse.scan_type;
      if (rootState.player.loginType === ExternalWagerLoginTypes.ClerkDepositTicket) {
        formData.ClerkId = rootState.player.clerk.user_id; // assign which clerk doing the betting for ticket
      }
      _api.post('/bet/confirmations-deposit-ticket', formData).then(getBetConfirmationCallback);
    }

    function getBetConfirmationsMobileScanCode() {
      formData.bets = bets;
      formData.selections = selections;
      formData.LoginType = ExternalWagerLoginTypes.MobileScanCode;
      formData.ScanCode = rootState.depositTicketStore.scanCode; // sending for balance control and authentication
      formData.MacAddress = rootState.settings.macAddress;
      formData.ScanType = rootState.depositTicketStore.balanceResponse.scan_type;

      _api.post('/bet/confirmations-mobile-scancode', formData).then(getBetConfirmationCallback);
    }

    function getBetConfirmationsClerk() {
      formData.bets = bets;
      formData.selections = selections;
      formData.LoginType = LoginTypes.Clerk;
      formData.MacAddress = rootState.settings.macAddress;
      formData.ClerkId = rootState.player.clerk.user_id; // assign which clerk doing the betting for customer
      _api
        .post('/bet/confirmations-clerk', formData)
        .then(getBetConfirmationCallback)
        .then(res => {
          const generatedDepositCode = res.data.Data.generatedDepositCode;
          commit('depositTicketStore/setScanCode', generatedDepositCode, {
            root: true,
          });
        });
    }

    function getBetConfirmationCallback(res) {
      return new Promise((resolve, reject) => {
        commit('setShowDisabledLinesModal', false);
        if (res.data.IsSuccess) {
          if (res.data.Data.lineNotAvailable) {
            const disabledLines = res.data.Data.disabledLines;
            const disabledLinesWithSelectionDescription = disabledLines.map(selection => {
              for (let i = 0; i < state.betOptionsResponse.length; i++) {
                const bet = state.betOptionsResponse[i];
                for (let j = 0; j < bet.bet.line_selections.length; j++) {
                  const _selection = bet.bet.line_selections[j];
                  if (_selection.selection_identifier === selection.selection_identifier) {
                    selection.selection_description = _selection.selection_description;
                  }
                }
              }
              return selection;
            });
            commit('setBetConfirmationDisabledLines', disabledLinesWithSelectionDescription);
            commit('setShowDisabledLinesModal', true);
          } else {
            const betConfirmationIds = res.data.Data.map(row => row.BetId);
            // log("[BETSLIP] betConfirmationIds", betConfirmationIds)
            commit('setBetConfirmationIds', betConfirmationIds);
            const confirmationResponse = res.data.Data;
            const confirmationResponseFromState = state.betConfirmationResponse;

            const betConfirmationResponseCloned = confirmationResponse.map(betOuter => {
              for (var i = 0; i < confirmationResponseFromState.length; i++) {
                const _oldBet = confirmationResponseFromState[i];
                if (betOuter) {
                  if (isSameSelection5(betOuter, _oldBet)) {
                    assignSelectionNewOddsForConfirmation(
                      selection,
                      _oldBet.odds_after_points,
                      _oldBet.spread_after_points,
                      'wait_for_accept_get_confirmation',
                    );
                  }
                  return selection;
                }
              }
              return betOuter;
            });

            commit('setBetConfirmationResponse', betConfirmationResponseCloned);
            commit('setCurrentState', 'BET_CONFIRMATION');
          }

          resolve(res);
        } else {
          const exceptionMessage = res.data.ExceptionMessage;
          commit('setBetConfirmationErrors', exceptionMessage);
          reject(res);
        }
        commit('updateBetConfirmationStatus', { loading: false });
      });
    }
  },
  // second and last state of bet placing
  placeBet: ({ state, rootState, rootGetters, commit, dispatch }) => {
    commit('updateBetPlaceStatus', { loading: true });
    const currencySymbol = rootGetters['player/currencySymbol'];

    const betOptions = state.confirmationData;
    const requestPlace = {
      UseFreePlayAvailable: state.activeFreeBet,
      IfBetRiskAmount: 0,
      MainWagerType: state.selectedType,
      Bets: [],
    };

    betOptions.forEach(item => {
      if (item.WagerType === 'if_win' || item.WagerType === 'if_win_or_tie') {
        requestPlace.IfBetRiskAmount = item.input_risk_amount;
        requestPlace.SecurityCode = item.SecurityCode;
        item.Selections.forEach(selection => {
          let betHeader = {
            Amount: selection.input_risk_amount,
            WagerType: item.WagerType,
            IdWagerType: item.IdWagerType,
            RiskWin: item.RiskWin,
            OpenSpots: 0,
            Details: [selection],
            RoundRobinCombinations: item.RoundRobinCombinations,
            RoundRobinCombinationAmounts: item.RoundRobinCombinationAmounts,
          };
          requestPlace.Bets.push(betHeader);
        });
      } else {
        let betHeader = {
          Amount: item.input_risk_amount,
          WagerType: item.WagerType,
          IdWagerType: item.IdWagerType,
          SubWagerType: item.IdWagerType,
          RiskWin: item.RiskWin,
          OpenSpots: 0,
          Details: item.Selections,
          RoundRobinCombinations: item.RoundRobinCombinations,
          RoundRobinCombinationAmounts: item.RoundRobinCombinationAmounts,
        };
        requestPlace.Bets.push(betHeader);
        requestPlace.SecurityCode = item.SecurityCode;
      }
    });
    // if (betOptions.WagerType === 'straight') {
    //   betOptions.Selections.forEach(item => {
    //     if (!item.Point) item.Point = 0;
    //     let betHeader = {
    //       Amount: item.input_risk_amount,
    //       WagerType: betOptions.WagerType,
    //       IdWagerType: betOptions.IdWagerType,
    //       RiskWin: 2,
    //       OpenSpots: 0,
    //       Details: [item]
    //     };
    //     requestPlace.Bets.push(betHeader);
    //   });
    // }

    const betIds = state.betConfirmationIds;
    const prevBetPlaceResponse = state.betPlaceResponse;
    const betPlaceIterationCount = state.betPlaceIterationCount;

    // if bet place iteration is greater than zero and clerk is logged
    // calculate rejected bets and deduce from auto generated deposit ticket
    // TODO: call deposit ticket
    if (betPlaceIterationCount > 0 && rootState.player.loginType === LoginTypes.Clerk) {
      // get the bets which are not accepted, and deduct their amount from deposit  balance
      const betsToDeduce = requestPlace.Bets.filter(bet => {
        if (requestPlace.WagerType === 'straight') {
          const identifier = bet.OutComeId;
          return state.rejectingBets[identifier];
        } else {
          const identifier = requestPlace.WagerType;
          return state.rejectingBets[identifier];
        }
      });

      log('current betsToDeduce', betsToDeduce);
      if (betsToDeduce.length > 0) {
        deductAmountFromTicketForRemainingBets(betsToDeduce);
      }
    }

    //CHECK-FV3
    // this check means player didn't accepted any line change in BetSlipBetPlaceModalLineChanged modal
    // if (!formData.betIds || formData.betIds.length === 0) {
    //   const ticketJson = {
    //     barcode: prevBetPlaceResponse.bet_scan_code,
    //     bets: snq(() => prevBetPlaceResponse.WagerResponseModel.bets, []), // browserda patlıyor. electronda dolu
    //     currency: rootState.settings.terminalInfo.currency_name,
    //     deposit_code: '', // hide deposit code when betting using RealPlayerKiosk, because he doesn't have a deposit code.
    //     response: prevBetPlaceResponse,
    //   };

    //   if (
    //     rootState.player.loginType === ExternalWagerLoginTypes.DepositTicket ||
    //     rootState.player.loginType === ExternalWagerLoginTypes.ClerkDepositTicket ||
    //     rootState.player.loginType === LoginTypes.Clerk
    //   ) {
    //     ticketJson.deposit_code = rootState.depositTicketStore.scanCode;
    //   }

    //   const printTicket = ({ callback, addCalc, isDeposit }) => {
    //     checkCanPrintBets({
    //       res: prevBetPlaceResponse,
    //       saltResponse: true,
    //       callback: function () {
    //         printWagerTicket({
    //           clientType: rootState.settings.clientType,
    //           ticketJson,
    //           lang: rootState.settings.selectedLocale.code,
    //           callback: function (arg) {
    //             commit('clerkDepositStore/setPrinterStatus', { success: arg.success }, { root: true });
    //             if (callback) {
    //               callback();
    //             }
    //           },
    //         });
    //       },
    //       addCalc,
    //       forcePrint: true,
    //       isDeposit,
    //     });
    //   };
    //   // if user is a deposit ticket logged or logged in with normal account from kiosk, print his wager ticket
    //   if (
    //     rootState.player.loginType === ExternalWagerLoginTypes.DepositTicket ||
    //     rootState.player.loginType === ExternalWagerLoginTypes.ClerkDepositTicket
    //   ) {
    //     printTicket({
    //       callback: function () {
    //         dispatch('depositTicketStore/tryGetDepositTicketOpenBets', null, {
    //           root: true,
    //         });

    //         dispatch('depositTicketStore/tryScanDepositTicket', null, {
    //           root: true,
    //         });
    //       },
    //       isDeposit: true,
    //     });

    //     dispatch('settings/getClerkBalance', null, { root: true });
    //   }

    //   if (rootState.player.loginType === LoginTypes.Player && rootState.settings.clientType === 'ANDROID_TABLET') {
    //     dispatch('player/tryGetBalance', null, { root: true });
    //     dispatch('openBetsStore/tryGetOpenBets', null, { root: true });
    //     printTicket();
    //     dispatch('settings/getClerkBalance', null, { root: true });
    //   }

    //   if (rootState.player.loginType === LoginTypes.Player && rootState.settings.clientType === 'ELECTRON') {
    //     dispatch('player/tryGetBalance', null, { root: true });

    //     printTicket({
    //       callback: function () {
    //         dispatch('openBetsStore/tryGetOpenBets', null, { root: true });
    //         dispatch('settings/getClerkBalance', null, { root: true });
    //       },
    //     });
    //   }

    //   if (rootState.player.loginType === LoginTypes.Player && rootState.settings.clientType !== 'ELECTRON') {
    //     dispatch('player/tryGetBalance', null, { root: true });
    //     dispatch('openBetsStore/tryGetOpenBets', null, { root: true });
    //   }

    //   if (rootState.player.loginType === LoginTypes.Clerk) {
    //     printTicket({
    //       addCalc: true,
    //       callback: function () {
    //         dispatch('settings/getClerkBalance', null, { root: true });
    //       },
    //     });
    //   }

    //   commit('setCurrentState', 'BET_PLACED');

    //   commit('updateBetPlaceStatus', { loading: false });
    //   prevBetPlaceResponse.generated_bets = prevBetPlaceResponse.generated_bets.filter(
    //     (bet) => !(bet.error && formData.betIds.indexOf(bet.bet.id) == -1),
    //   );
    //   commit('setBetPlaceResponse', {
    //     betPlaceResponse: prevBetPlaceResponse,
    //   });
    //   return;
    // }

    // is user logged in with normal account from not ELECTRON
    if (rootState.player.loginType === LoginTypes.Player && rootState.settings.clientType === 'WEB') {
      placeBetRealPlayer();
    }

    // is user logged in with normal account from not ELECTRON
    if (rootState.player.loginType === LoginTypes.Player && rootState.settings.clientType === 'ANDROID_TABLET') {
      placeBetRealPlayerKiosk();
    }

    // is user logged in with normal account from Kiosk?
    if (rootState.player.loginType === LoginTypes.Player && rootState.settings.clientType === 'ELECTRON') {
      placeBetRealPlayerKiosk();
    }

    // is user logged in using deposit ticket?
    if (
      rootState.player.loginType === ExternalWagerLoginTypes.DepositTicket ||
      rootState.player.loginType === ExternalWagerLoginTypes.ClerkDepositTicket
    ) {
      placeBetDepositTicket();
    }

    if (rootState.player.loginType === ExternalWagerLoginTypes.MobileScanCode) {
      placeBetMobileScanCode();
    }

    // is clerk is playing for a customer
    if (rootState.player.loginType === LoginTypes.Clerk) {
      placeBetClerk();
    }

    function placeBetRealPlayer() {
      requestPlace.LoginType = LoginTypes.Player;
      requestPlace.AcceptOddsChanges = state.acceptOddChanges;

      _api
        .post('/v2/bet/placebetrealplayer', requestPlace, {
          headers: {
            'X-Forwarded-For': rootState.settings.userIpInfo.ip,
          },
        })
        .then(res => {
          commit('increaseBetPlaceIterationCount');
          if (res.data.IsSuccess) {
            //clearSuccessBetsFromInput(res, false); // TODO <-- come back maybe

            const betPlaceResponse = res.data.Data;
            commit('setCurrentState', 'BET_PLACED');
            commit('setBetPlaceResponse', {
              betPlaceResponse,
              isDomine: true,
            });

            // clearSuccessBetsFromInputWithGeneratedBets(snq(() => state.betPlaceResponse.generated_bets, []) || [], false);

            const hasSuccess = betPlaceResponse.filter(row => row.IsSuccess).length > 0;
            if (hasSuccess) {
              //dispatch("getBetTabs");
              //dispatch("getBetOptions");

              dispatch('player/tryGetBalance', null, {
                root: true,
              });
              dispatch('openBetsStore/tryGetOpenBets', null, {
                root: true,
              });
              commit('setBetConfirmationIds', []);
            } else {
              // if there is an error
              // only try to place bets with error, because other bets are successfully placed
              const betConfirmationIds = betPlaceResponse
                .filter(row => row.IsSuccess)
                .map(row => row.Details.map(m => m.OutComeId));
              commit('setBetConfirmationIds', betConfirmationIds);
            }
          } else {
            handleBetPlaceError(res);
          }
          commit('updateBetPlaceStatus', {
            loading: false,
          });
        });
    }

    function placeBetRealPlayerKiosk() {
      formData.betIds = betIds;
      requestPlace.LoginType = ExternalWagerLoginTypes.RealPlayerKiosk;
      requestPlace.MacAddress = rootState.settings.macAddress;
      requestPlace.AcceptOddsChanges = state.acceptOddChanges;

      _api.post('/bet/place-real-player-kiosk', formData).then(res => {
        commit('increaseBetPlaceIterationCount');
        if (res.data.IsSuccess) {
          clearSuccessBetsFromInput(res, false);
          const betPlaceResponse = res.data.Data;
          commit('setCurrentState', 'BET_PLACED');
          commit('setBetPlaceResponse', { betPlaceResponse, isDomine: true });
          const hasError = betPlaceResponse.generated_bets.filter(row => !!row.error).length > 0;
          if (!hasError) {
            //dispatch("getBetTabs");
            //dispatch("getBetOptions");

            // get his balance and open bets after successfull placing
            dispatch('player/tryGetBalance', null, { root: true });
            dispatch('openBetsStore/tryGetOpenBets', null, { root: true });
            checkCanPrintBets({ res });
            commit('setBetConfirmationIds', []);
          } else {
            // if there is an error
            // only try to place bets with error, because other bets are successfully placed
            const betConfirmationIds = betPlaceResponse.generated_bets.filter(row => row.error).map(row => row.bet.id);
            commit('setBetConfirmationIds', betConfirmationIds);
          }
        } else {
          handleBetPlaceError(res);
        }
        commit('updateBetPlaceStatus', { loading: false });
      });
    }

    function placeBetDepositTicket() {
      requestPlace.AcceptOddsChanges = state.acceptOddChanges;
      requestPlace.LoginType = ExternalWagerLoginTypes.DepositTicket;
      requestPlace.ScanCode = rootState.depositTicketStore.scanCode; // sending for balance control and authentication
      requestPlace.MacAddress = rootState.settings.macAddress;
      requestPlace.ScanType = rootState.depositTicketStore.balanceResponse.scan_type;
      requestPlace.TicketNumber = rootState.depositTicketStore.balanceResponse.ticket_number;
      if (rootState.player.loginType === ExternalWagerLoginTypes.ClerkDepositTicket) {
        requestPlace.ClerkId = rootState.player.clerk.user_id; // assign which clerk doing the betting for ticket
      }
      const taxHelper = Vue.prototype.$taxHelper;
      const mustApplyTax = taxHelper.mustApplyTax;
      if (mustApplyTax) {
        requestPlace.Bets = requestPlace.Bets.map(bet => {
          const appliedTaxRiskInputHidden = taxHelper.applyTaxToRiskInputHidden({
            input_risk_amount: bet.Amount,
          });
          bet.Amount = appliedTaxRiskInputHidden;
          return bet;
        });
      }
      _api.post('v2/bet/placebetdepositticket', requestPlace).then(res => {
        commit('increaseBetPlaceIterationCount');
        if (res.data.IsSuccess) {
          //clearSuccessBetsFromInput(res, false);

          // commit('setCurrentState', 'BET_PLACED');
          //dispatch("getBetTabs");
          //dispatch("getBetOptions");

          const betPlaceResponse = res.data.Data;
          const placedBetIds = betPlaceResponse.PlaceResponse
            .filter(row => row.IsSuccess)
            .map(row => row.TicketNumber);
          commit('setPlacedBets', []);
          commit('setPlacedBets', placedBetIds);

          commit('setCurrentState', 'BET_PLACED');
          commit('updateBetPlaceStatus', { loading: false, error: true });

          commit('setBetPlaceResponse', { betPlaceResponse: betPlaceResponse.PlaceResponse, isDomine: true });
          const hasError = betPlaceResponse.PlaceResponse.filter(row => !row.IsSuccess).length > 0;
          if (!hasError) {
            // get his balance and open bets after successfull placing

            checkCanPrintBets({
              res,
              isDeposit: true,
              callback: function () {
                dispatch('depositTicketStore/tryScanDepositTicket', null, {
                  root: true,
                });
              },
            });
          } else {
            // if there is an error
            // only try to place bets with error, because other bets are successfully placed
            const betConfirmationIds = betPlaceResponse.PlaceResponse.filter(row => !row.IsSuccess).map(row => row.TicketNumber);
            commit('setBetConfirmationIds', betConfirmationIds);
          }
        } else {
          handleBetPlaceError(res);
        }
        //commit('updateBetPlaceStatus', { loading: false });
      });
    }

    function placeBetMobileScanCode() {
      requestPlace.LoginType = ExternalWagerLoginTypes.MobileScanCode;
      requestPlace.AcceptOddsChanges = state.acceptOddChanges;
      requestPlace.MacAddress = rootState.settings.macAddress;
      requestPlace.ScanType = rootState.depositTicketStore.balanceResponse.scan_type;
      requestPlace.ScanCode = rootState.depositTicketStore.scanCode;
      requestPlace.TicketNumber = rootState.depositTicketStore.balanceResponse.ticket_number;

      const taxHelper = Vue.prototype.$taxHelper;
      const mustApplyTax = taxHelper.mustApplyTax;
      if (mustApplyTax) {
        requestPlace.Bets = requestPlace.Bets.map(bet => {
          let appliedRoundRobinCombinationAmounts = '';
          if (bet.RoundRobinCombinationAmounts) {
            var splitBets = bet.RoundRobinCombinationAmounts.split('|');
            for (let i = 0; i < splitBets.length; i++) {
              const element = splitBets[i];
              var amountSplit = element.split('@');
              const appliedAmount = taxHelper.applyTaxToRiskInputHidden({
                input_risk_amount: amountSplit[1],
              });
              if (appliedRoundRobinCombinationAmounts) appliedRoundRobinCombinationAmounts += '|';
              appliedRoundRobinCombinationAmounts += `${amountSplit[0]}@${appliedAmount}`;
            }
            bet.RoundRobinCombinationAmounts = appliedRoundRobinCombinationAmounts;
            return bet;
          }
          else {
            const appliedTaxRiskInputHidden = taxHelper.applyTaxToRiskInputHidden({
              input_risk_amount: bet.Amount,
            });
            bet.Amount = appliedTaxRiskInputHidden;
            return bet;
          }
        });
      }

      _api.post('v2/bet/place-mobile-scancode', formData).then(res => {
        commit('increaseBetPlaceIterationCount');
        if (res.data.IsSuccess) {
          //clearSuccessBetsFromInput(res, false);

          // commit('setCurrentState', 'BET_PLACED');
          //dispatch("getBetTabs");
          //dispatch("getBetOptions");

          const betPlaceResponse = res.data.Data;
          const placedBetIds = betPlaceResponse.PlaceResponse
            .filter(row => row.IsSuccess)
            .map(row => row.TicketNumber);
          commit('setPlacedBets', placedBetIds);

          commit('setCurrentState', 'BET_PLACED');

          commit('setBetPlaceResponse', { betPlaceResponse: betPlaceResponse.PlaceResponse, isDomine: true });
          commit('updateBetPlaceStatus', { loading: false, error: true });
          const hasError = betPlaceResponse.PlaceResponse.filter(row => !row.IsSuccess).length > 0;

          if (!hasError) {
            checkCanPrintBets({
              res,
              isDeposit: true,
              callback: function() {
                console.log('no callback');
              },
            });
          } else {
            // if there is an error
            // only try to place bets with error, because other bets are successfully placed
            const betConfirmationIds = betPlaceResponse.PlaceResponse.filter(row => !row.IsSuccess).map(row => row.TicketNumber);
            commit('setBetConfirmationIds', betConfirmationIds);
          }
        } else {
          handleBetPlaceError(res);
        }
        //commit('updateBetPlaceStatus', { loading: false });
      });
    }

    function placeBetClerk() {
      requestPlace.LoginType = LoginTypes.Clerk;
      requestPlace.AcceptOddsChanges = state.acceptOddChanges;
      requestPlace.MacAddress = rootState.settings.macAddress;
      requestPlace.ScanType = rootState.depositTicketStore.balanceResponse.scan_type;
      requestPlace.ScanCode = rootState.depositTicketStore.scanCode;

      // formData.bets = buildBets(state, false, true);

      const taxHelper = Vue.prototype.$taxHelper;
      const mustApplyTax = taxHelper.mustApplyTax;
      if (mustApplyTax) {
        requestPlace.Bets = requestPlace.Bets.map(bet => {
          let appliedRoundRobinCombinationAmounts = '';
          if (bet.RoundRobinCombinationAmounts) {
            var splitBets = bet.RoundRobinCombinationAmounts.split('|');
            for (let i = 0; i < splitBets.length; i++) {
              const element = splitBets[i];
              var amountSplit = element.split('@');
              const appliedAmount = taxHelper.applyTaxToRiskInputHidden({
                input_risk_amount: amountSplit[1],
              });
              if (appliedRoundRobinCombinationAmounts) appliedRoundRobinCombinationAmounts += '|';
              appliedRoundRobinCombinationAmounts += `${amountSplit[0]}@${appliedAmount}`;
            }
            bet.RoundRobinCombinationAmounts = appliedRoundRobinCombinationAmounts;
            return bet;
          }
          else {
            const appliedTaxRiskInputHidden = taxHelper.applyTaxToRiskInputHidden({
              input_risk_amount: bet.Amount,
            });
            bet.Amount = appliedTaxRiskInputHidden;
            return bet;
          }
        });
      }

      requestPlace.ClerkId = rootState.player.clerk.user_id; // assign which clerk doing the betting for customer

      const isDepositTicket = rootGetters['player/isDepositTicket'];

      _api.post('/v2/bet/placebetclerk', requestPlace).then(res => {
        commit('updateBetPlaceStatus', { loading: false });
        commit('increaseBetPlaceIterationCount');
        if (res.data.IsSuccess) {
          // clearSuccessBetsFromInput(res);

          commit('setCurrentState', 'BET_PLACED');
          //dispatch("getBetTabs");
          //dispatch("getBetOptions");

          const betPlaceResponse = res.data.Data;

          commit('setBetPlaceResponse', { betPlaceResponse: betPlaceResponse.PlaceResponse, isDomine: true });
          commit('updateBetPlaceStatus', { loading: false, error: true });
          const hasError = betPlaceResponse.PlaceResponse.filter(row => !row.IsSuccess).length > 0;

          const placedBetIds = betPlaceResponse.PlaceResponse
            .filter(row => row.IsSuccess)
            .map(row => row.TicketNumber);
          commit('setPlacedBets', placedBetIds);

          if (!hasError) {
            checkCanPrintBets({
              res,
              saltResponse: false,
              addCalc: true,
            });
          } else {
            // if there is an error
            // only try to place bets with error, because other bets are successfully placed
            const betConfirmationIds = betPlaceResponse.PlaceResponse.filter(row => !row.IsSuccess).map(row => row.TicketNumber);
            commit('setBetConfirmationIds', betConfirmationIds);
          }
        } else {
          handleBetPlaceError(res);
        }
        commit('updateBetPlaceStatus', { loading: false });
        dispatch('settings/getClerkBalance', null, { root: true });
      });
    }

    function handleBetPlaceError(res) {
      const errorCode = res.data.error_code ? ' ' + res.data.error_code : '';
      const exceptionMessage = res.data.ExceptionMessage;
      commit('updateBetPlaceStatus', { loading: false, error: true });

      if (exceptionMessage[0] === 'TOKEN_NOT_FOUND') {
        dispatch('player/logout', null, { root: true });
      }
      exceptionMessage.map(i => {
        Vue.toasted.show(i18n.t('Exceptions.' + i) + errorCode, {
          type: 'error',
          position: 'bottom-center',
          duration: 5000,
        });
      });
    }

    function checkCanPrintBets({ res, saltResponse, addCalc, forcePrint, isDeposit, callback }) {
      let betPlaceResponse = null;
      if (saltResponse) {
        betPlaceResponse = res;
      } else {
        betPlaceResponse = res.data.Data;
      }
      const can_print_bets = betPlaceResponse.can_print_bets;
      log('can_print_bets', can_print_bets);
      if (!forcePrint) {
        if (can_print_bets == false) return;
      }

      commit('updateBetPlaceStatus', { loading: true });

      const wager_ids = state.placedBets.join(',');

      const formData = {
        mac_address: rootState.settings.macAddress,
        wager_ids,
        utc: rootState.settings.timeZone.code
      };

      if (isDeposit) {
        formData.TicketNumber = rootState.depositTicketStore.balanceResponse.ticket_number;
      }

      if (wager_ids.length === 0) {
        // hiç wager id yok ise ilk place işleminde tüm checkbolar no işaretlenmiştir. yani bet yapılacak bir durum yok
        commit('closeBetSlip');
        return;
      }

      commit('updateBetPlaceStatus', { loading: true });
      commit('updateRegisterBetStatus', { loading: true });
      dispatch('setPrinting', true);
      _api
        .post('/v2/bet/register-bets', formData)
        .then(res => {
          commit('updateRegisterBetStatus', { loading: false });
          const exeception = snq(() => res.data.ExceptionMessage[0]);
          const exeptionList = [
            'registerBetsAndDeposit.selfPurchaseLimit',
            'CreateDepositWithBets_NOT_OK',
            'CLERK_WAGER_ERROR'
          ]
          if (exeception) {
            if ( exeptionList.some( exp => exp == exeception ) ) {
              openErrorModal({
                title: exeception == 'selfPurchaseLimit'
                    ? 'Exceptions.registerBetsAndDeposit.selfPurchaseLimit'
                    : 'Exceptions.ERROR_OCCURRED'
              });

              commit('updateBetPlaceStatus', { loading: false });
              commit('setCurrentState', 'BET_PREPARE');
              dispatch('setPrinting', false);
              return;
            }
          }

          if (!res.data.IsSuccess) {
            handleBetPlaceError(res);
            commit('updateBetPlaceStatus', { loading: false });
            dispatch('setPrinting', false);
            return;
          } else {
            /*
            clearSuccessBetsFromInputWithGeneratedBets(
              snq(() => state.betPlaceResponse.generated_bets, []) || [],
              false,
            );
             */
          }

          commit('updateBetPlaceStatus', { loading: false });

          const betPlaceResponseRegister = res.data.Data;
          const getCurrentPlaceResponse = state.betPlaceResponse;
          betPlaceResponseRegister.places = getCurrentPlaceResponse;
          commit('setBetPlaceResponse', { betPlaceResponse: betPlaceResponseRegister, isDomine: true });

          const betPlaceResponseFromState = state.betPlaceResponse;

          const generated_bets = snq(() => betPlaceResponseFromState.generated_bets, []) || [];

          commit('setBetPlaceResponse', {
            betPlaceResponse: {
              ...betPlaceResponseFromState,
              generated_bets: generated_bets.filter(row => !row.error),
            },
          });

          if (rootState.player.loginType === ExternalWagerLoginTypes.MobileScanCode) {
            if (rootState.settings.isScanningCodeForMobile) {
              let mobileQrParameters = rootState.settings.mobileQRParameters;
              _api.get(`/qrwalet/scanBalance?scanCode=${mobileQrParameters.scanCode}`).then(result => {
                const availableBalance = result.data.Data.available_balance;
                const ticketNumber = result.data.Data.ticket_number;
                commit(
                  'depositTicketStore/setBalanceResponse',
                  { available_balance: availableBalance, ticket_number: ticketNumber, scan_type: 'W' },
                  { root: true },
                );
              });
            }
            return;
          }
          commit('depositTicketStore/setScanCode', betPlaceResponseRegister.bet_scan_code, {
            root: true,
          });
          const ticketJson = {
            barcode: betPlaceResponseRegister.bet_scan_code,
            bets: betPlaceResponseRegister.WagerResponseModel.bets,
            currency: rootState.settings.terminalInfo.currency_name,
            deposit_code: '', // hide deposit code when betting using RealPlayerKiosk, because he doesn't have a deposit code.
            response: betPlaceResponseRegister,
            betPlacement: true,
          };
          if (
            rootState.player.loginType === ExternalWagerLoginTypes.DepositTicket ||
            rootState.player.loginType === ExternalWagerLoginTypes.ClerkDepositTicket ||
            rootState.player.loginType === LoginTypes.Clerk
          ) {
            ticketJson.deposit_code = rootState.depositTicketStore.scanCode;
          }

          log('ticketJson going to print successfully', ticketJson);

          commit('setCurrentState', 'BET_PLACED');

          if (callback) {
            callback();
          }

          printWagerTicket({
            clientType: rootState.settings.clientType,
            ticketJson,
            lang: rootState.settings.selectedLocale.code,
            callback: function (arg) {
              commit('clerkDepositStore/setPrinterStatus', { success: arg.success }, { root: true });
            },
          });
          if (addCalc && !rootGetters['player/isDepositTicket']) {
            const totalAmount = snq(() => betPlaceResponseRegister.WagerResponseModel.bets, [])
              .map(item => item.wager_header.risk)
              .reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue), 0);

            const totalTaxes = Vue.prototype.$taxHelper.calculateTaxAndFeeFromWagerResponse(
              betPlaceResponseRegister.WagerResponseModel.bets,
            );
            commit(
              'depositTicketStore/addCalc',
              {
                type: 'bet',
                ticketNumber: betPlaceResponseRegister.WagerResponseModel.bets.map(item => item.dgs_wager_id).join(','),
                amount: totalAmount + parseFloat(totalTaxes.totalRiskTaxAndFee),
              },
              {
                root: true,
              },
            );
          }
          dispatch('settings/getClerkBalance', null, { root: true });

          if (isDeposit && parseFloat(rootState.depositTicketStore.balanceResponse.available_balance) === 0) {
            this.$api
              .post('/customers/endcustomersession', { mac_address: rootState.settings.macAddress })
              .then(res => { });
          }
        })
        .finally(() => {
          dispatch('setPrinting', false);
        });
    }

    function clearSuccessBetsFromInput(res, reset = true) {
      // retain bets check edili ise silme!
      if (res.data.IsSuccess && !state.retainBets) {
        const generated_bets = res.data.Data.generated_bets;
        console.log('clearSuccessBetsFromInput', { generated_bets });
        generated_bets.map(bet => {
          if (!bet.error && bet.data) {
            if (bet.bet.type === 'straight') {
              var betid = bet.bet.line_selections[0].selection_identifier;
              dispatch('removeBetFromSelections', { selection_id: betid, reset });
              dispatch('removeBetFromSlip', { betid, get_options: false, reset });
            } else {
              dispatch('removeBetFromSlipByType', bet.bet.type);
            }
          }
        });
      }
    }

    function clearSuccessBetsFromInputWithGeneratedBets(generated_bets, reset = true) {
      // retain bets check edili ise silme!
      generated_bets.map(bet => {
        if (!bet.error && bet.data) {
          if (bet.bet.type === 'straight') {
            let betid = snq(() => bet.bet.line_selections[0].selection_identifier);
            if (isChecked(betid)) return;
            dispatch('removeBetFromSelections', { selection_id: betid, reset });
            dispatch('removeBetFromSlip', { betid, get_options: false, reset });
          } else {
            let betid = snq(() => bet.bet.line_selections[0].selection_identifier);
            if (isChecked(betid)) return;
            dispatch('removeBetFromSlipByType', bet.bet.type);
          }
        }
      });
    }

    function deductAmountFromTicketForRemainingBets(bets) {
      const payload = {
        bets: bets,
        ScanCode: rootState.depositTicketStore.scanCode,
        MacAddress: rootState.settings.macAddress,
        ClerkId: rootState.player.clerk.user_id, // assign which clerk doing the betting for customer
      };
      return;
      _api.post('/bet/place-clerk/deduct-from-ticket', payload).then(res => {
        log(res.data);
      });
    }
  },
  placeBetUnconfirmed: ({ state, rootState, rootGetters, commit, dispatch }) => {
    commit('updateBetPlaceStatus', { loading: true });
    const currencySymbol = rootGetters['player/currencySymbol'];
    const betIds = state.betConfirmationIds;
    const prevBetPlaceResponse = state.betPlaceResponse;
    const betPlaceIterationCount = state.betPlaceIterationCount;
    const formData = {
      betIds,
      bet_group_id: prevBetPlaceResponse.bet_group_id || 0,
      bet_scan_code: prevBetPlaceResponse.bet_scan_code || null,
    };

    placeBetRealPlayerFreeWager();

    function placeBetRealPlayerFreeWager() {
      formData.bets = buildBets(state, false, true);
      _api.post('/bet/place-unconfirmed', formData).then(res => {
        commit('increaseBetPlaceIterationCount');
        if (res.data.IsSuccess) {
          const betPlaceResponse = res.data.Data;
          commit('setCurrentState', 'BET_PLACED');
          commit('setBetPlaceResponse', betPlaceResponse);
          const hasError = betPlaceResponse.generated_bets.filter(row => !!row.error).length > 0;
          if (!hasError) {
            // get his balance, open bets and free wagers after successfull placing
            dispatch('openBetsStore/tryGetOpenBets', null, { root: true });
            dispatch('freeWagerStore/tryGetAvailableFreeWagers', null, {
              root: true,
            });
          }
        } else {
          handleBetPlaceError(res);
        }
        commit('updateBetPlaceStatus', { loading: false });
      });
    }

    function handleBetPlaceError(res) {
      const exceptionMessage = res.data.ExceptionMessage;
      exceptionMessage.map(i => {
        Vue.toasted.show(i18n.t('Exceptions.' + i), {
          type: 'error',
          position: 'bottom-center',
          duration: 5000,
        });
      });
    }
  },
  tryAddRejectedBet({ commit, state }, bet) {
    const betPlaceResponse = state.betPlaceResponse;
    let generated_bets = (betPlaceResponse && betPlaceResponse.generated_bets) || [];
    generated_bets = generated_bets.filter(b => b.bet.id !== bet.bet.id);

    console.log({ generated_bets });

    commit('setBetPlaceResponse', {
      betPlaceResponse: {
        ...betPlaceResponse,
        generated_bets,
      },
    });
    if (bet.bet.type === 'straight') {
      commit('addRejectedBet', {
        identifier: bet.bet.line_selections[0].selection_identifier,
        bet,
      });
    } else {
      commit('addRejectedBet', {
        identifier: bet.bet.type,
        bet,
      });
    }
  },
  tryRemoveRejectedBet({ commit }, bet) {
    if (bet.bet.type === 'straight') {
      commit('removeRejectedBet', {
        identifier: bet.bet.line_selections[0].selection_identifier,
      });
    } else {
      commit('removeRejectedBet', {
        identifier: bet.bet.type,
      });
    }
  },
  removeBetFromConfirmation({ commit }, bet) {
    commit('removeBetConfirmationId', bet);
    const betConfirmationResponse = state.betConfirmationResponse;
    const betConfirmationResponseNew = [];
    betConfirmationResponse.forEach(_bet => {
      if (_bet.bet.id !== bet.bet.id) {
        betConfirmationResponseNew.push(_bet);
      }
    });

    commit('setBetConfirmationResponse', betConfirmationResponseNew);

    if (betConfirmationResponseNew.length === 0) {
      commit('resetBetSlip');
    }
  },
  checkLineAvailability({ state, commit }) {
    // TODO: disable for now
    // const selections = state.selections;
    // if (selections.size == 0) return;
    // _api.post('/bet/line-availability', selections.toJSON()).then(res => {
    //   if (res.data.IsSuccess) {
    //     const disabledLines = res.data.Data.filter(selection => selection.is_available == false);
    //     if (disabledLines.length == 0) return;
    //     const disabledLinesWithSelectionDescription = disabledLines.map(selection => {
    //       for (let i = 0; i < state.betOptionsResponse.length; i++) {
    //         const bet = state.betOptionsResponse[i]
    //         for (let j = 0; j < bet.bet.line_selections.length; j++) {
    //           const _selection = bet.bet.line_selections[j];
    //           if (_selection.selection_identifier === selection.selection_identifier) {
    //             selection.selection_description = _selection.selection_description;
    //           }
    //         }
    //       }
    //       return selection;
    //     })
    //     commit("setBetConfirmationDisabledLines", disabledLinesWithSelectionDescription);
    //     commit("setShowDisabledLinesModal", true);
    //   }
    // })
  },
  closeDisableLinesModal({ state, dispatch, commit }) {
    state.betConfirmationDisabledLines.map(selection => {
      dispatch('removeBetFromSelections', { selection_id: selection.selection_identifier });
      dispatch('removeBetFromSlip', {
        selection_id: selection.selection_identifier,
        get_options: false,
      });
    });
    dispatch('getBetTabs');
    dispatch('getNewBetOptions');
    commit('setShowDisabledLinesModal', false);
    commit('setCurrentState', 'BET_PREPARE');
  },
  startCheckLineAvailityInterval({ dispatch, rootState }) {
    dispatch('clearCheckLineAvailityInterval'),
      (checkLineAvailabilityInterval = setInterval(() => {
        dispatch('checkLineAvailability');
      }, rootState.settings.lineAvailabilityInterval));
  },
  clearCheckLineAvailityInterval() {
    if (checkLineAvailabilityInterval) {
      clearInterval(checkLineAvailabilityInterval);
    }
  },
  // bet lines updating from socket
  // compares bet slip to if it has changed odd
  setSocketData: ({ state, commit }, data) => {
    const betOptionsResponse = state.betOptionsResponse;
    if (!betOptionsResponse) return;
    if (!betOptionsResponse.Selections) return;

    betOptionsResponse.Selections.forEach(selection => {
      let socketChange = data.find(d => d.gmid == selection.MarketId);
      if (socketChange) {
        socketChange.omdl.forEach(socketOutcome => {
          if (socketOutcome.oid == selection.OutComeId) {
            assignSelectionNewOdds(selection, socketOutcome.odd, socketOutcome.pts, 'wait_for_accept');
          }
        });
      }
    });

    // data.forEach(socketDat => {
    //   betOptionsResponse.Selections.forEach(selection => {
    //     socketDat.omdl.forEach(socketOutcome => {
    //       if (socketOutcome.oid == selection.OutComeId) {
    //         assignSelectionNewOdds(selection, socketOutcome.odd, socketOutcome.pts, 'wait_for_accept');
    //       }
    //     })
    //   });
    // });
    // const selections = state.newBetSlipSelection;
    // if (!selections) return;
    // const betOptionsResponse = state.betOptionsResponse;
    // if (!betOptionsResponse) return;
    // const newSelections = selections.OutComeList ? selections.OutComeList.map((selection) => {
    //   for (var i = 0; i < data.length; i++) {
    //     const game = data[i];
    //     if (isSameSelection4(selection, game)) assignSelectionNewOdds(selection, game.cov, game.csv);
    //   }
    //   return selection;
    // }) : [];

    // const betOptionsResponseCloned = betOptionsResponse.Selections ? betOptionsResponse.Selections.map((betOuter) => {
    //   for (var i = 0; i < data.length; i++) {
    //     const game = data[i];
    //     if (betOuter && betOuter.OutComeId) {
    //       if (isSameSelection3(betOuter, game)) {
    //         assignSelectionNewOdds(betOuter, game.cov, game.csv, 'wait_for_accept');
    //       }
    //     }
    //   }
    //   return betOuter;
    // }) : [];

    // const betConfirmationResponse = state.betConfirmationResponse;

    // const betConfirmationResponseCloned = betConfirmationResponse.Selections ? betConfirmationResponse.Selections.map((betOuter) => {
    //   for (var i = 0; i < data.length; i++) {
    //     const game = data[i];
    //     if (betOuter && betOuter.OutComeId) {
    //       if (isSameSelection3(betOuter, game)) {
    //         assignSelectionNewOddsForConfirmation(selection, game.cov, game.csv, 'wait_for_get_confirmation');
    //       }
    //     }
    //   }
    //   return betOuter;
    // }) : [];

    // selections.OutComeList = newSelections;
    // commit('setNewBetSelection', selections);
    // commit('setBetConfirmationResponse', betConfirmationResponseCloned);
    // commit('setBetOptionsResponse', betOptionsResponseCloned);
  },
  acceptOddChange({ commit, state }, selection_identifier) {
    const betOptionsNew = state.betOptionsResponse;
    betOptionsNew.Selections = betOptionsNew.Selections.map(bet => {
      if (bet.OutComeId === selection_identifier) {
        Vue.delete(selection, 'wait_for_accept');
      }
      return selection;
    });
    commit('setBetOptionsResponse', betOptionsNew);
  },
  // bet lines updating from http request
  // compares also bet slip if it has any changed odd
  checkAndCompareLines: ({ state, commit }, lines) => {
    return;
    const newSelections = state.selections.map(selection => {
      for (let i = 0; i < lines.length; i++) {
        const header = lines[i];
        for (let j = 0; j < header.line_list.length; j++) {
          const game = header.line_list[j];
          if (isSameSelection2(selection, game.odds.money_lines.home))
            assignSelectionNewOdds(
              selection,
              game.odds.money_lines.home.odd_value,
              game.odds.money_lines.home.spread_value,
            );
          else if (isSameSelection2(selection, game.odds.money_lines.visitor))
            assignSelectionNewOdds(
              selection,
              game.odds.money_lines.visitor.odd_value,
              game.odds.money_lines.visitor.spread_value,
            );
          else if (isSameSelection2(selection, game.odds.money_lines.draw))
            assignSelectionNewOdds(
              selection,
              game.odds.money_lines.draw.odd_value,
              game.odds.money_lines.draw.spread_value,
            );
          // special_money_lines
          else if (isSameSelection2(selection, game.odds.special_money_lines)) {
            const tournament = game.odds.special_money_lines.tournament;
            if (tournament) {
              for (let x = 0; x < tournament.length; x++) {
                const odd = tournament[x];
                assignSelectionNewOdds(selection, odd.odd_value, odd.spread_value);
              }
            }
          }

          // spreads
          else if (isSameSelection2(selection, game.odds.spreads.home))
            assignSelectionNewOdds(selection, game.odds.spreads.home.odd_value, game.odds.spreads.home.spread_value);
          else if (isSameSelection2(selection, game.odds.spreads.visitor))
            assignSelectionNewOdds(
              selection,
              game.odds.spreads.visitor.odd_value,
              game.odds.spreads.visitor.spread_value,
            );
          // totals
          else if (isSameSelection2(selection, game.odds.totals.under))
            assignSelectionNewOdds(selection, game.odds.totals.under.odd_value, game.odds.totals.under.spread_value);
          else if (isSameSelection2(selection, game.odds.totals.over))
            assignSelectionNewOdds(selection, game.odds.totals.over.odd_value, game.odds.totals.over.spread_value);
        }
      }
      return selection;
    });

    const betOptionsResponseCloned = state.betOptionsResponse.map(betOuter => {
      if (betOuter.bet && betOuter.bet.line_selections) {
        betOuter.bet.line_selections = betOuter.bet.line_selections.map(selection => {
          for (let i = 0; i < lines.length; i++) {
            const header = lines[i];
            for (let j = 0; j < header.line_list.length; j++) {
              const game = header.line_list[j];
              if (isSameSelection(selection, game.odds.money_lines.home))
                assignSelectionNewOdds(
                  selection,
                  game.odds.money_lines.home.odd_value,
                  game.odds.money_lines.home.spread_value,
                  'wait_for_accept',
                );
              else if (isSameSelection(selection, game.odds.money_lines.visitor))
                assignSelectionNewOdds(
                  selection,
                  game.odds.money_lines.visitor.odd_value,
                  game.odds.money_lines.visitor.spread_value,
                  'wait_for_accept',
                );
              else if (isSameSelection(selection, game.odds.money_lines.draw))
                assignSelectionNewOdds(
                  selection,
                  game.odds.money_lines.draw.odd_value,
                  game.odds.money_lines.draw.spread_value,
                  'wait_for_accept',
                );
              // special_money_lines
              else if (isSameSelection2(selection, game.odds.special_money_lines)) {
                const tournament = game.odds.special_money_lines.tournament;
                if (tournament) {
                  for (let x = 0; x < tournament.length; x++) {
                    const odd = tournament[x];
                    assignSelectionNewOdds(selection, odd.odd_value, odd.spread_value, 'wait_for_accept');
                  }
                }
              }
              // spreads
              else if (isSameSelection(selection, game.odds.spreads.home))
                assignSelectionNewOdds(
                  selection,
                  game.odds.spreads.home.odd_value,
                  game.odds.spreads.home.spread_value,
                  'wait_for_accept',
                );
              else if (isSameSelection(selection, game.odds.spreads.visitor))
                assignSelectionNewOdds(
                  selection,
                  game.odds.spreads.visitor.odd_value,
                  game.odds.spreads.visitor.spread_value,
                  'wait_for_accept',
                );
              // totals
              else if (isSameSelection(selection, game.odds.totals.under))
                assignSelectionNewOdds(
                  selection,
                  game.odds.totals.under.odd_value,
                  game.odds.totals.under.spread_value,
                  'wait_for_accept',
                );
              else if (isSameSelection(selection, game.odds.totals.over))
                assignSelectionNewOdds(
                  selection,
                  game.odds.totals.over.odd_value,
                  game.odds.totals.over.spread_value,
                  'wait_for_accept',
                );
            }
          }

          return selection;
        });
      }
      return betOuter;
    });

    commit('setSelections', newSelections);
    commit('setBetOptionsResponse', betOptionsResponseCloned);
  },
  retainBets: ({ commit }, value) => {
    commit('retainBets', value);
  },
  setPrinting: ({ commit }, value) => {
    commit('setPrinting', value);
  },
  fillConfirmationData: ({ state, commit, dispatch, rootState }, value) => {
    let result = [];
    let betMain = state.betOptionsResponse;
    if (state.selectedType === 'straight') {
      betMain.Selections.forEach(f => {
        if (!f.input_risk_amount) return;
        if (f.PointsPurchased) {
          f.OutComeId = f.BuyPointOutcomeId;
        }
        let straightObject = {
          ErrorMessage: betMain.ErrorMessage,
          ErrorMessageKey: betMain.ErrorMessageKey,
          ErrorMessageParams: betMain.ErrorMessageParams,
          FillIdWager: betMain.FillIdWager,
          FreePlayAvailable: betMain.FreePlayAvailable,
          IdWagerType: betMain.IdWagerType,
          IsFillOpenBets: betMain.IsFillOpenBets,
          IsSuccess: betMain.IsSuccess,
          RiskWin: betMain.RiskWin,
          SecurityCode: betMain.SecurityCode,
          input_risk_amount: f.input_risk_amount,
          input_win_amount: f.input_win_amount,
          Selections: [f],
          WagerType: 'straight',
          AcceptOddsChanges: state.acceptOddChange
        };
        result.push(straightObject);
      });
    } else if (state.selectedType === 'parlay') {
      let parlayObject = {
        ErrorMessage: betMain.ErrorMessage,
        ErrorMessageKey: betMain.ErrorMessageKey,
        ErrorMessageParams: betMain.ErrorMessageParams,
        FillIdWager: betMain.FillIdWager,
        FreePlayAvailable: betMain.FreePlayAvailable,
        IdWagerType: betMain.IdWagerType,
        IsFillOpenBets: betMain.IsFillOpenBets,
        IsSuccess: betMain.IsSuccess,
        RiskWin: betMain.RiskWin,
        SecurityCode: betMain.SecurityCode,
        Selections: betMain.Selections.map(m => {
          if (m.PointsPurchased) {
            m.OutComeId = f.BuyPointOutcomeId;
          }
          return m;
        }),
        input_risk_amount: betMain.input_risk_amount,
        input_win_amount: betMain.input_win_amount,
        WagerType: 'parlay',
        fixedParlayMultiply: betMain.fixedParlayMultiply
      };
      result.push(parlayObject);
    } else if (state.selectedType === 'round_robin') {

      let roundRobinCombin = '';
      let roundRobinCombinAmounts = '';

      if (state.roundRobinTab.straightBetRiskAmount) {
        roundRobinCombin += '1';
        roundRobinCombinAmounts += `1@${state.roundRobinTab.straightBetRiskAmount}`;
      }

      let keys = Object.keys(state.roundRobinTab.roundRobinsAmounts);



      for (let index = 0; index < keys.length; index++) {
        const element = state.roundRobinTab.roundRobinsAmounts[keys[index]];
        if (element && keys[index] != 99) {
          if (roundRobinCombin) roundRobinCombin += ',';
          if (roundRobinCombinAmounts) roundRobinCombinAmounts += '|';
          roundRobinCombin += `${keys[index]}`;
          roundRobinCombinAmounts += `${keys[index]}@${element}`;
        } else if (element && keys[index] == 99) {
          for (let yIndex = 2; yIndex <= betMain.Selections.length; yIndex++) {
            if (roundRobinCombin) roundRobinCombin += ',';
            if (roundRobinCombinAmounts) roundRobinCombinAmounts += '|';
            roundRobinCombin += `${yIndex}`;
            roundRobinCombinAmounts += `${yIndex}@${element}`;
          }
        }
      }

      let betObject = {
        ErrorMessage: betMain.ErrorMessage,
        ErrorMessageKey: betMain.ErrorMessageKey,
        ErrorMessageParams: betMain.ErrorMessageParams,
        FillIdWager: betMain.FillIdWager,
        FreePlayAvailable: betMain.FreePlayAvailable,
        IdWagerType: betMain.IdWagerType,
        IsFillOpenBets: betMain.IsFillOpenBets,
        IsSuccess: betMain.IsSuccess,
        RiskWin: betMain.RiskWin,
        SecurityCode: betMain.SecurityCode,
        RoundRobinCombinations: roundRobinCombin,
        RoundRobinCombinationAmounts: roundRobinCombinAmounts,
        Selections: betMain.Selections.map(m => {
          if (m.PointsPurchased) {
            m.OutComeId = f.BuyPointOutcomeId;
          }
          return m;
        }),
        input_risk_amount: betMain.rrRisk,
        input_win_amount: betMain.rrWinAmount,
        WagerType: 'round_robin',
      };
      betObject.input_win_amount = getWinAmountRR(betObject);
      result.push(betObject);
    } else if (state.selectedType === 'if_win' || state.selectedType === 'if_win_or_tie') {
      let parlayObject = {
        ErrorMessage: betMain.ErrorMessage,
        ErrorMessageKey: betMain.ErrorMessageKey,
        ErrorMessageParams: betMain.ErrorMessageParams,
        FillIdWager: betMain.FillIdWager,
        FreePlayAvailable: betMain.FreePlayAvailable,
        IdWagerType: betMain.IdWagerType,
        IsFillOpenBets: betMain.IsFillOpenBets,
        IsSuccess: betMain.IsSuccess,
        RiskWin: betMain.RiskWin,
        SecurityCode: betMain.SecurityCode,
        Selections: betMain.Selections.map(m => {
          if (m.PointsPurchased) {
            m.OutComeId = f.BuyPointOutcomeId;
          }
          return m;
        }),
        input_risk_amount: betMain.input_risk_amount,
        input_win_amount: betMain.input_win_amount,
        WagerType: state.selectedType,
      };
      result.push(parlayObject);
    } else if (state.selectedType === 'teaser') {
      let parlayObject = {
        ErrorMessage: betMain.ErrorMessage,
        ErrorMessageKey: betMain.ErrorMessageKey,
        ErrorMessageParams: betMain.ErrorMessageParams,
        FillIdWager: betMain.FillIdWager,
        FreePlayAvailable: betMain.FreePlayAvailable,
        IdWagerType: betMain.IdWagerType,
        SubWagerType: betMain.IdWagerType,
        IsFillOpenBets: betMain.IsFillOpenBets,
        IsSuccess: betMain.IsSuccess,
        RiskWin: betMain.RiskWin,
        SecurityCode: betMain.SecurityCode,
        Selections: betMain.Selections.map(m => {
          if (m.PointsPurchased) {
            m.OutComeId = f.BuyPointOutcomeId;
          }
          m.Point = m.OriginalPoint;
          return m;
        }),
        input_risk_amount: betMain.input_risk_amount,
        input_win_amount: betMain.input_win_amount,
        WagerType: state.selectedType,
      };
      result.push(parlayObject);
    }
    commit('setConfirmationData', result);
  },
  fillRoundRobinData: ({ state, commit, dispatch, rootState }, value) => {
    commit('setRoundRobinsData', value);
  },
};

function isSameSelection(selection, game) {
  let isSame = false;
  if (!selection || !game) isSame = false;
  else if (game.id === selection.selection_identifier) isSame = true;
  return isSame;
}

function isSameSelection2(selection, game) {
  let isSame = false;
  if (!selection || !game) isSame = false;
  else if (game.id === selection.id) isSame = true;
  return isSame;
}

function isSameSelection3(selection, game) {
  let isSame = false;
  if (!selection || !game) isSame = false;
  else if (game.oid === selection.OutComeId) isSame = true;
  // log("selection_identifier", selection.selection_identifier, "socket identifier", game.id, "isSame", isSame)
  return isSame;
}

function isSameSelection5(newSelection, oldSelection) {
  let isSame = false;
  if (!newSelection || !oldSelection) isSame = false;
  else if (newSelection.BetId === oldSelection.BetId) isSame = true;
  // log("selection id", selection.id, "socket identifier", game.id, "isSame", isSame)
  return isSame;
}

function isSameSelection4(selection, game) {
  let isSame = false;
  if (!selection || !game) isSame = false;
  else if (game.oid === selection.id) isSame = true;
  // log("selection id", selection.id, "socket identifier", game.id, "isSame", isSame)
  return isSame;
}

// assign from socket data
function assignSelectionNewOdds(selection, odd_value, spread_value, wait_for_accept) {
  const acceptOddChanges = store.state.betSlip.acceptOddChanges;
  if (selection.odds_modified_by_user) return;
  if (!odd_value) return;
  // odd control
  function diffCheck(v1, v2) {
    if (!acceptOddChanges) {
      return true;
    }
    v1 = parseFloat(v1);
    v2 = parseFloat(v2);
    const dif = Math.abs(v1 - v2);
    const percent10 = Math.abs((v2 * 10) / 100);
    const isGreater = dif >= percent10;

    if (isGreater) {
      console.log({ isGreater, dif, v1, v2, acceptOddChanges });
    }

    return isGreater;
  }

  if (parseFloat(odd_value) > parseFloat(selection.Odd)) {
    if (wait_for_accept) {
      const check = diffCheck(odd_value, selection.Odd);
      Vue.set(selection, 'wait_for_accept', check);
    }
    Vue.set(selection, 'changed_type', 'plus');
    Vue.set(selection, 'Odd', odd_value);
    Vue.set(selection, 'new_odds', odd_value);
  } else if (parseFloat(odd_value) < parseFloat(selection.Odd)) {
    if (wait_for_accept) {
      const check = diffCheck(odd_value, selection.Odd);
      Vue.set(selection, 'wait_for_accept', check);
    }
    Vue.set(selection, 'changed_type', 'minus');
    Vue.set(selection, 'Odd', odd_value);
    Vue.set(selection, 'new_odds', odd_value);
  }
  // spread control
  if (parseFloat(spread_value) > parseFloat(selection.Point)) {
    if (wait_for_accept) {
      const check = diffCheck(spread_value, selection.Point);
      Vue.set(selection, 'wait_for_accept', check);
    }
    Vue.set(selection, 'changed_type', 'plus');
    Vue.set(selection, 'Point', spread_value);
    Vue.set(selection, 'new_point', spread_value);
  } else if (parseFloat(spread_value) < parseFloat(selection.Point)) {
    if (wait_for_accept) {
      const check = diffCheck(spread_value, selection.Point);
      Vue.set(selection, 'wait_for_accept', check);
    }
    Vue.set(selection, 'changed_type', 'minus');
    Vue.set(selection, 'Point', spread_value);
    Vue.set(selection, 'new_point', spread_value);
  }
  return selection;
}
function assignSelectionNewOddsForConfirmation(selection, odd_value, spread_value, wait_for_accept_key) {
  const acceptOddChanges = store.state.betSlip.acceptOddChanges;
  if (selection.odds_modified_by_user) return;
  if (!odd_value) return;
  // odd control
  function diffCheck(v1, v2) {
    if (!acceptOddChanges) {
      return true;
    }
    v1 = parseFloat(v1);
    v2 = parseFloat(v2);
    const dif = Math.abs(v1 - v2);
    const percent10 = Math.abs((v2 * 10) / 100);
    const isGreater = dif >= percent10;

    if (isGreater) {
      console.log({ isGreater, dif, v1, v2, acceptOddChanges });
    }

    return isGreater;
  }

  if (parseFloat(odd_value) > parseFloat(selection.odds_after_points)) {
    if (wait_for_accept_key) {
      const check = diffCheck(odd_value, selection.odds);
      Vue.set(selection, wait_for_accept_key, check);
    }
    Vue.set(selection, 'changed_type', 'plus');
    Vue.set(selection, 'odds', odd_value);
    Vue.set(selection, 'new_odds', odd_value);
  } else if (parseFloat(odd_value) < parseFloat(selection.odds_after_points)) {
    if (wait_for_accept_key) {
      const check = diffCheck(odd_value, selection.odds);
      Vue.set(selection, wait_for_accept_key, check);
    }
    Vue.set(selection, 'changed_type', 'minus');
    Vue.set(selection, 'odds', odd_value);
    Vue.set(selection, 'new_odds', odd_value);
  }
  // spread control
  if (parseFloat(spread_value) > parseFloat(selection.spread_after_points)) {
    if (wait_for_accept_key) {
      const check = diffCheck(spread_value, selection.spread);
      Vue.set(selection, wait_for_accept_key, check);
    }
    Vue.set(selection, 'changed_type', 'plus');
    Vue.set(selection, 'spread', spread_value);
    Vue.set(selection, 'new_spread', spread_value);
  } else if (parseFloat(spread_value) < parseFloat(selection.spread_after_points)) {
    if (wait_for_accept_key) {
      const check = diffCheck(spread_value, selection.spread);
      Vue.set(selection, wait_for_accept_key, check);
    }
    Vue.set(selection, 'changed_type', 'minus');
    Vue.set(selection, 'spread', spread_value);
    Vue.set(selection, 'new_spread', spread_value);
  }
  return selection;
}

function animateOddObjectToBetslip(odd, event) {
  const targetToReachX = Math.floor(window.innerWidth / 2 - 20); // Estimated X position of mobile bet slip icon
  const targetToReachY = Math.floor(window.innerHeight - 20); // Estimated Y position of mobile bet slip icon
  let currentX = event.x;
  let currentY = event.y;

  const oddSpan = document.createElement('span');
  oddSpan.style.padding = '2px 5px';
  oddSpan.style.zIndex = 100;
  oddSpan.style.position = 'fixed';
  oddSpan.style.background = 'var(--color3)';
  oddSpan.style.borderRadius = '2px';
  oddSpan.style.color = 'white';
  oddSpan.style.maxWidth = '50px';
  oddSpan.style.width = '50px';
  oddSpan.style.overflow = 'hidden';
  oddSpan.innerHTML = odd.odds_american;

  document.body.append(oddSpan);

  var coords = { x: currentX, y: currentY };
  new TWEEN.Tween(coords)
    .to({ x: targetToReachX, y: targetToReachY }, 1200)
    .easing(TWEEN.Easing.Back.InOut)
    .onUpdate(function () {
      oddSpan.style.left = coords.x + 'px';
      oddSpan.style.top = coords.y + 'px';
    })
    .onComplete(function () {
      oddSpan.parentNode.removeChild(oddSpan);
    })
    .start();

  function anim(time) {
    TWEEN.update(time);
    requestAnimationFrame(anim);
  }

  anim();
}

export const betSlip = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
